<template lang="pug">
v-row.entity-controller.pa-5(:class="{ ['flex-column']: vertical }")
  v-col.entity-controller_header.py-0
    v-row
      v-col.d-flex.align-center
        slot(name="label", :value="getLabel", v-bind="{ invert }")
          h2.primary--text {{ getLabel.replace(/_/g, " ") }}
      v-col.d-flex.justify-end(v-if="except")
        g-btn.h9.primary--text(@click.stop="onClick") {{$t('Common.createNew')}} {{ $tc(`${entityName}._name`, 1) }}
    app-simple-entity-search(:error-messages="searchErrors", :loads="searchLoads", :wheres="extraWhere", v-bind="{ entity, disabled }", @input="setInstance")
  v-col.entity-controller_display.py-0(v-if="!isEmptyDisplay")
    slot(name="entityDisplay", :value="displayObject", v-bind="{ entity }")
      v-row
        v-col
          app-entity-display(
            :value="displayObject",
            @edit="onEditDisplay",
            @close="onCloseDisplay",
            v-bind="{ entity }",
          )
  v-dialog(
    v-model="dialog",
    max-width="979",
    persistent,
  )
    v-card
      g-btn(icon, small, :style="{ position: 'absolute', right: '5px', top: '5px' }" ,@click="onCloseBtn")
        v-icon mdi-close
      app-entity(
        modalInstance,
        :path="null",
        :selector="false",
        invert,
        v-bind="$props",
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")
      v-card-actions
        v-spacer
        g-btn(@click="onCloseBtn") {{$t('Common.cancel')}}
        g-btn(color="primary", @click="onSaveBtn") {{$t('Common.save')}}
</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    invert: {
      type: Boolean,
      default: true,
    },
    entity: null,
    relation: null,
    vertical: {
      type: Boolean,
      default: false,
    },
    extraLoad: {
      type: Array,
      default: () => ([])
    },
    extraWhere: {
      type: Array,
      default: () => ([])
    },
    chips: null,
    parentInstance: null,
    parent: null,
    path: null,
    parentPath: null,
    showInfo: null,
    extraData: null,
    isSection: null,
    isActive: null,
  },
  // props: ['extraLoad', 'chips', 'parentInstance', 'parent', 'entity', 'relation', 'path', 'parentPath', 'selector', 'selectorOnly', 'showInfo', 'extraData', 'isSection', 'isActive'],
  data: () => ({
    dialog: false,
    testValue: {
      externalID: 'GAAA000001',
      name: 'Transports South America',
      addressLine1: '405 Sky Tower North',
      addressLine2: 'Building A, Suite 2',
      city: 'San Mateo, California, US',
      PO: 4530,
      remarks: 'Blue door',
      extraField1: 'Content',
      extraField2: 'Content',
      extraField3: 'Content',
    },
  }),
  methods: {
    setInstance(instance) {
      let entityState = _.get(this.parentInstance, 'entityState');
      const { id } = instance;
      if (entityState === 3) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.$getParentKey(this.parent, this.path), value: id });
      }
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: instance });
    },
    onClick() {
      this.$store.commit('SET_MODAL_INSTANCE', { extraData: [], entityState: 4, _Entity: this.entity.name });
      this.dialog = true;
    },
    onCloseDisplay() {
      let entityState = _.get(this.parentInstance, 'entityState');
      if (entityState === 3) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.$getParentKey(this.parent, this.path), value: null });
      }
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: null });
    },
    onEditDisplay() {
      this.$store.commit('SET_MODAL_INSTANCE', { ...this.instance });
      this.dialog = true;
    },
    async onSaveBtn() {
      try  {
        const { data } = (await axios.post('entity/graph', this.modalInstanceObj));
        this.setInstance({ ...data, entityState: 3 });
        this.$store.commit('SET_MODAL_ERRORS', {});
        this.dialog = false;
      } catch(e) {
        let { response: { data: { errors } } } = e;
        // console.log('ERRORS ', errors);
        this.$store.commit('SET_MODAL_ERRORS', errors);
      }
    },
    onCloseBtn() {
      this.$store.commit('SET_MODAL_ERRORS', {});
      this.dialog = false;
    },
    getExtraData(field, extraData) {
      return extraData.find(e => Number(e.extraFieldId) === Number(field.extraFieldId))
    },
  },
  computed: {
    except() {
      return this.entity.name !== 'Action'
    },
    // Linked modalInstance, this entityController mixin points to instance
    modalInstanceObj() {
      return this.$store.state.modalInstance;
    },
    entityName() {
      return _.get(this.entity, 'name');
    },
    getLabel() {
      const relationName = _.get(this.relation, 'name');
      const parentName = _.get(this.parent, 'name');
      const customLabelObj = this.$getCustomLabel(parentName) || {};
      const labelAttribute = relationName || this.entityName;

      const customLabel = _.get(customLabelObj, labelAttribute);
      if(customLabel) return this.$camelToString(this.$displayName(customLabel));

      if (relationName) {
        const translated = this.$tCheckC(`${parentName}.${relationName}`, '');
        if (!_.isEmpty(translated)) return translated;
      }

      return this.$camelToString(this.$displayName(labelAttribute));
    },
    // Error related computeds
    errors() {
      return this.$store.state.errors;
    },
    labelHash() {
      return this.path;
    },
    hasErrors() {
      return Object.keys(this.errors).find(k => k.includes(this.labelHash));
    },
    searchErrors() {
      return (this.hasErrors && 'Select valid') || '';
    },
    // Display object related computeds
    primitivesFields() {
      return _.chain(this.fields).map(field => ({ label: field.label, name: this.$lcfirst(field.name), type: field.type })).value();
    },
    primitivesObj() {
      return _.chain(this.primitivesFields)
        .reduce((acc, { name, label, type }) => {
          if (_.isNil(this.instance)) return acc;
          let attrLabel = this.$tCheck(`${this.entityName}.${name}`, label || name);
          let value;
          if (['DateTime', 'Datetime', 'Date'].includes(type) && !_.isNil(this.instance[name])) {
            value = this.$dateFormatted(this.$dateTimezoneConvert(this.instance[name]));
          } else {
            let attrName = name;
            if (name === 'hTSCode') attrName = 'htsCode';
            if (name === 'uNCode') attrName = 'unCode';
            value = this.instance[attrName];
          }
          return ({ ...acc, [attrLabel]: value })
        }, {})
        .value();
    },
    extraFieldGroups() {
      return _.get(this.entity, 'fields', []).filter(f => f.extra && (!f.section || f.section === this.entityName) );
    },
    allExtraFields() {
      return _.chain(this.extraFieldGroups || []).reduce((acc, group) => {
        return [...acc, ...group.fields]
      } ,[]).value();
    },
    extraFieldsObj() {
      return _.chain(this.allExtraFields)
        .reduce((acc, field) => {
          const name = field.label || field.name;
          let val = (this.getExtraData(field, (this.instance && this.instance.extraData) || []) || {}).value;
          if (['DateTime', 'Datetime', 'Date'].includes(field.type) && !_.isNil(val)) {
            val = this.$dateFormatted(this.$dateTimezoneConvert(val));
          }
          return ({...acc, [name]: val})
        }, {})
        .value();
    },
    displayObject() {
      return this.MergeSmart(this.primitivesObj, this.extraFieldsObj );
    },
    // If the primitivesObj has all values as null, empty or undefined. Then it is "empty".
    isEmptyDisplayObject() {
      return Object.keys(this.displayObject).every((key) => !this.displayObject[key]);
    },
    // If Any of the following is empty then not show Display: primitivesObk, instance, displayObject
    isEmptyDisplay() {
      return _.isEmpty(this.displayObject) || _.isEmpty(this.instance) || this.isEmptyDisplayObject;
    },
    // Selector needs to load extraData if posible
    searchLoads() {
      return this.$isExtraDateable(this.entity) ? ['ExtraData', ...this.extraLoad] : [...this.extraLoad];
    },
  },
}
</script>
